import { render, staticRenderFns } from "./DisclosureShippingCompany.vue?vue&type=template&id=34ad6848&scoped=true&"
import script from "./DisclosureShippingCompany.vue?vue&type=script&lang=ts&"
export * from "./DisclosureShippingCompany.vue?vue&type=script&lang=ts&"
import style0 from "./DisclosureShippingCompany.vue?vue&type=style&index=0&id=34ad6848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ad6848",
  null
  
)

export default component.exports